import React from 'react'

import { CTAButtonWithWT } from '@f-fertighaus/applications/Next/components/common/CTAButton'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'

export const RequestFreeInfoCTA = () => {
  const {
    state: { vendor_nid, active }
  } = useHouseDetail()

  const isDisabled = !active

  return (
    <CTAButtonWithWT
      disabled={isDisabled}
      variant='contained'
      color='primary'
      sx={{ margin: 'auto' }}
      wtPayload={{
        category: 'CTA-button',
        action: 'click',
        label: 'floor-plan-CTA',
        indicates: ['funnel-entry'],
        location: 'floorplan-section',
        values: [
          {
            type: 'text',
            value: t(`houseDetailPage.floor_plans.cta_button_text`)
          }
        ]
      }}
      data-request-type='house-detail-form'
      data-funnel-variant='house-wizard-item-configuration'
      {...(vendor_nid && { 'data-vendor-nid': vendor_nid })}
      className='js-request-button'>
      {t(`houseDetailPage.floor_plans.cta_button_text`)}
    </CTAButtonWithWT>
  )
}
